<template>
  <b-container fluid class="position-relative h-100">
    <div
      v-if="isMessagesLoading"
      class="my-5 d-flex flex-column align-items-center justify-content-center"
    >
      <half-circle-spinner />
      <div class="spinner-message text-center">
        Loading...
      </div>
    </div>
    <message-view
      v-else-if="mode === modes.VIEW && this.selectedMessage"
      :message="selectedMessage"
      @close="handleViewClose"
      @reply="handleReply"
    />
    <message-form
      v-else-if="mode === modes.CREATE"
      receiver-name="Recruiter"
      :reply-on-msg="selectedMessage"
      :match-id="match.id"
      @cancel="handleNewMsgCancel"
      @new-msg-created="handleNewMsg"
    />
    <template v-else>
      <b-row class="v2_line_height_28">
        <b-col
          cols="8"
          lg="4"
          offset-lg="4"
          class="d-flex justify-content-start justify-content-md-center align-items-center font-weight-bold"
        >
          Messages
        </b-col>
      </b-row>
      <b-row v-if="messages.length === 0">
        <b-col cols="12" class="text-center mt-3 v2_font_size_18">
          You don't have messages yet.
        </b-col>
      </b-row>
      <messages-list
        v-else
        :messages="messages"
        @mark-as-read="markMessageAsRead"
        @open="openMessage"
        @close-message-list="$emit('close-message-list')"
      />
    </template>
  </b-container>
</template>

<script>
import MessagesList from '@/components/messages/MessagesList';
import MessageView from '@/components/messages/MessageView';
import MessageForm from '@/components/messages/MessageForm';
import { HalfCircleSpinner } from 'epic-spinners';
import { VIEW_MODES } from '@/components/exchange/job-profiles-list/JobProfileJobOfferListItem';

const MODES = {
  LIST: 'VIEW_MODE',
  VIEW: 'VIEW',
  CREATE: 'CREATE',
};

export default {
  name: 'JobProfileMessageCenter',
  props: {
    viewMode: String,
    match: Object,
    messages: Array,
    isMessagesLoading: Boolean,
    mode: String
  },
  components: {
    MessagesList,
    MessageView,
    MessageForm,
    HalfCircleSpinner,
  },
  data: function () {
    return {
      selectedMessageId: null,
    };
  },
  mounted() {
    const mode = this.viewMode === VIEW_MODES.NEW_MSG ? MODES.CREATE : MODES.LIST;
    this.$emit('mode-changed', mode);
  },
  computed: {
    selectedMessage: function () {
      return this.messages.find(({ id }) => this.selectedMessageId === id);
    },
    modes: function () {
      return MODES;
    },
    loaderId: function () {
      return `loading_${this.$options.name}`;
    },
  },
  methods: {
    markMessageAsRead: async function (id) {
      this.$emit('mark-as-read', id);
    },
    openMessage: function (id, markAsRead) {
      this.selectedMessageId = id;
      if (markAsRead) {
        this.markMessageAsRead(id);
      }
      this.$emit('mode-changed', MODES.VIEW);
    },
    openCreateForm: function () {
      this.$emit('mode-changed', MODES.CREATE);
    },
    handleNewMsgCancel: function () {
      const mode = this.selectedMessageId ? MODES.VIEW : MODES.LIST;
      this.$emit('mode-changed', mode);
    },
    handleViewClose: function () {
      this.selectedMessageId = null;
      this.$emit('mode-changed', MODES.VIEW);
    },
    handleReply: function () {
      this.$emit('mode-changed', MODES.CREATE);
    },
    handleNewMsg: function (newMsg) {
      this.$emit('new-msg-created', newMsg);
      this.$emit('mode-changed', MODES.LIST);
    },
  },
  watch: {
    viewMode: function (newVal) {
      if (newVal === VIEW_MODES.NEW_MSG && this.mode !== MODES.CREATE) {
        this.$emit('mode-changed', MODES.CREATE);
      }
    },
  },
};
</script>

<style scoped></style>
